<template>
  <div class="flex flex-col gap-4">
    <Chips
      :label="sharingInEmailSharingMode ? 'Invite via email (only invited can see)' : 'Share content via email'"
      placeholder="Add People"
      data-testid="viewer-add-emails"
      v-model="newInvitations"
      pattern="^[^\s@]+@[^\s@]+\.[^\s@]+$"
      suffix-icon="general.paperPlane"
      classList="flex flex-wrap items-center justify-start gap-1 px-2 border border-slate-300 dark:border-zinc-700 rounded-10 focus-within:ring focus-within:border-blue-500 focus:ring focus:ring-blue-500/50"
      @click="trackEventClick"
      @submit="onSubmit()"
      @error="onInvalidEmail"
    />
    <Chips
      v-if="sharingInEmailSharingMode"
      data-testid="viewer-shared-emails"
      mode="readAndDelete"
      classList="flex flex-wrap items-center justify-start gap-1"
      :modelValue="invited"
      @update:modelValue="(value: any) => changeSharingEmails(toRaw(value))"
    />
  </div>
</template>
<script setup lang="ts">
import { ref, Ref, toRaw, watch } from 'vue';
import { storeToRefs } from 'pinia';
import { useViewerItemStore } from '@/modules/viewer/store/useViewerItemStore';
import { useSecurity } from '@/modules/viewer/composables/useSecurity';
import { useToast } from '@/composables/useToast';
import { Chips } from '@/storybook/form';
import { TrackClickEvents, useTrack } from '@/composables/useTrack';

const { trackClick } = useTrack();
const { error } = useToast();
const viewerItemStore = useViewerItemStore();
const { sharingInEmailSharingMode } = storeToRefs(viewerItemStore);
const { addSharingEmails, changeSharingEmails } = useSecurity();

const newInvitations: Ref<string[]> = ref([]);
const invited: Ref<string[]> = ref(viewerItemStore.sharingSpecificUsers || []);

const onSubmit = () => {
  trackClick(TrackClickEvents.SHARE_EMAIL_SUBMIT);
  addSharingEmails(toRaw(newInvitations.value));
  newInvitations.value = [];
};

const trackEventClick = () => trackClick(TrackClickEvents.SHARE_EMAIL_INPUT);

const onInvalidEmail = (value: string) => {
  error(`"${value}" is not a valid email address.`);
};

watch(
  () => viewerItemStore.sharingSpecificUsers,
  value => {
    invited.value = toRaw(value || []);
  }
);
</script>
